import * as React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Button, Stack, Typography, useMediaQuery } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';

interface GalleryImage {
  original: string;
  thumbnail: string;
}

type Props = {
  images: string[];
  closeGallery: () => void;
  currentIndex: number;
};

function MyImageGallery({ images, closeGallery, currentIndex }: Props) {
  // textInput must be declared here so the ref can refer to it
  const [galleryImages, setGalleryImages] = React.useState<GalleryImage[]>();
  const [imageCount, setImageCount] = React.useState<number>();
  const [currentImageIndex, setCurrentImageIndex] =
    React.useState<number>(currentIndex);
  const desktop = useMediaQuery('(min-width:744px)');

  React.useEffect(() => {
    async function loadImages() {
      if (images && images.length > 0) {
        setImageCount(images.length);
        const tempGalleryImages = images.map(image => ({
          original: image,
          thumbnail: image,
        }));

        setGalleryImages(tempGalleryImages);
      }
    }
    loadImages();
  }, [desktop, images]);

  return (
    <div>
      <Stack
        zIndex={5}
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        position="absolute"
        boxSizing="border-box"
        left={theme => theme.spacing(2)}
        top={theme => theme.spacing(2)}
        right={theme => theme.spacing(2)}>
        <Button
          onClick={closeGallery}
          sx={{
            p: 1,
            pl: 0,
            minWidth: 0,
          }}>
          <ChevronLeftIcon sx={{ color: 'common.white' }} />
        </Button>

        <Typography variant="overline" color="white">
          {currentImageIndex + 1} / {imageCount}
        </Typography>
      </Stack>
      {galleryImages && (
        <ImageGallery
          items={galleryImages}
          showNav={false}
          showPlayButton={false}
          showFullscreenButton
          onSlide={(index: number) => setCurrentImageIndex(index)}
          startIndex={currentIndex}
        />
      )}
    </div>
  );
}

export default MyImageGallery;
